import { Navigate, Outlet } from "react-router";
import { useWeb3Auth } from "@web3auth/modal-react-hooks";

const RequireAdminAuth = () => {
  const { isConnected } = useWeb3Auth();

  if (!isConnected) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
};

export default RequireAdminAuth;
